import * as React from "react";

const Document: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15"><g fill="#002554" fill-rule="evenodd"><path d="M14.034 16.25h-12.5c-.69 0-1.25-.56-1.25-1.25V2.5c0-.69.56-1.25 1.25-1.25H7.16V2.5H1.534V15h12.5V9.375h1.25V15c0 .69-.56 1.25-1.25 1.25Z"/><path d="M10.91 0v1.25h3.493L9.034 6.619l.881.881 5.37-5.369v3.494h1.25V0z"/></g></svg>
    );
};

export default React.memo(Document);
